import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { ThemeAudit } from "@/features/admin/components/theme-audit";
import { PageContainer } from "@fleet/ui";

function AdminThemeAuditPage() {
  return (
    <PageContainer maxWidth="6xl">
      <ThemeAudit />
    </PageContainer>
  );
}

export const adminThemeAuditRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/theme-audit",
  // Addressable audit selection (#15b §5): `?audit=<themeId>` or `?audit=all`.
  validateSearch: (search: Record<string, unknown>): { audit?: string } => ({
    audit:
      typeof search.audit === "string" && search.audit.trim() !== "" ? search.audit : undefined,
  }),
  component: AdminThemeAuditPage,
});
